// ConfirmationDialog.tsx
import React, { FC } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';

interface ConfirmationDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    message: string;
    title: string;
    confirmText?: string;
    cancelText?: string;
    confirmColor?: 'inherit' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
    isLoading?: boolean;
    maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
}

const ConfirmationDialog: FC<ConfirmationDialogProps> = (props) => {
    const { 
        open, 
        onClose, 
        onConfirm, 
        message, 
        title,
        confirmText = 'Confirm',
        cancelText = 'Cancel',
        confirmColor = 'primary',
        isLoading = false,
        maxWidth = 'sm'
    } = props;

    return (
        <Dialog open={open} onClose={onClose} maxWidth={maxWidth} fullWidth>
            {title && <DialogTitle sx={{textAlign:'center'}}>{title}</DialogTitle>}
            <DialogContent>
                <DialogContentText sx={{ color: '#666', mt: 2 }}>
                    {message}
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
                <Button 
                    onClick={onClose} 
                    color="inherit"
                    disabled={isLoading}
                >
                    {cancelText}
                </Button>
                <Box sx={{ position: 'relative' }}>
                    <Button 
                        onClick={onConfirm} 
                        color={confirmColor}
                        variant="contained"
                        disabled={isLoading}
                        autoFocus
                    >
                        {confirmText}
                    </Button>
                    {isLoading && (
                        <CircularProgress
                            size={24}
                            sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                marginTop: '-12px',
                                marginLeft: '-12px',
                            }}
                        />
                    )}
                </Box>
            </DialogActions>
        </Dialog>
    );
};

export default ConfirmationDialog;
